import React from "react";
import notcartimg from "../images/payfail.png";
import { NavLink } from "react-router-dom";
import Breadcomp from "../components/Common/Breadcomp";
import { MediaQueries } from "../components/utils";
const Paymentfail = () => {
     const { isMobile } = MediaQueries();

    return (
        <>
          <div className={`${isMobile ? 'pt-1 pb-1' : 'pt-3 pb-3'}`}>
                    <Breadcomp />
                </div>

                <div className="notlogin">
            <img src={notcartimg} alt="Order Success" />
            <div className="notlogintitle">Oh no! Your payment failed.</div>
            <div className="notloginsubtitle">
            An error occurred while processing your payment.
            </div>
            <div className="d-flex">
             
                <NavLink to="/Payment" className="notloginbtn textdecoration-none">
                Try again
                </NavLink>
            </div>
        </div>
        </>
    
    );
};

export default Paymentfail;
